import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useKeyLockerBoxAdminPinMutation } from "modules/KeyLockersDashboard/components/KeyLockerBoxesModal/hooks";

type OpenKeyLockerBoxModalProps = {
  id: number | null;
  openPinModal: (pin: string) => void;
  resetKeyLockerBoxId: () => void;
};

export const OpenKeyLockerBoxModal = ({ id, resetKeyLockerBoxId, openPinModal }: OpenKeyLockerBoxModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: openKeyLockerBox, isPending, data: keyLockerBoxResponse, isSuccess } = useKeyLockerBoxAdminPinMutation();

  useEffect(() => {
    if (isSuccess) openPinModal(keyLockerBoxResponse.pin);
  }, [isSuccess]);

  const handleOpenKeyLockerBox = async () => {
    if (!id) return;
    await openKeyLockerBox(id);
    resetKeyLockerBoxId();
  };

  return (
    <CustomConfirm
      isLoading={isPending}
      isOpen={Boolean(id)}
      type={CUSTOM_CONFIRM_TYPES.Danger}
      handleCancel={resetKeyLockerBoxId}
      handleConfirm={handleOpenKeyLockerBox}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_this_will_open_this_lockbox_but_wont_update_the_system", "This will open this locker box, but it will not update the system. Are you sure ?")}
    />
  );
};
